import { notificationApi as originNotificationApi } from '@bingads-webui-campaign/notification-center';
import { INotificationApi, INotificationExtraOptions } from '@bingads-webui-campaign-react/ads-studio-app-shared-components';

export const notificationApi: INotificationApi = {
  showWarning: (message: string, extraOptions?: INotificationExtraOptions): void | string => originNotificationApi.showWarning(message, extraOptions),
  showInfo: (message: string, extraOptions?: INotificationExtraOptions): void | string => originNotificationApi.showInfo(message, extraOptions),
  dismiss: (id: string): void => {
    originNotificationApi.dismiss(id);
  },
};
